import { addMethod, string } from 'yup';

addMethod(string, 'firstname', function (message) {
  return this.test('firstname-test', message, (value) => /^([\p{L}]+[-,. ']*[ ]*)+$/u.test(value ?? 'null'));
});
